export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/photogallery/deleteYoutubeVideo',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allYoutubeVideos'],
       
    })
